export enum DonorIntakeSituation {
    DirectedDonor = 1,
    StandardVoucher = 2,
    NonDirectedDonor = 3,
    FamilyVoucher = 4
}